import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Ear, Users, BookOpen, Mic } from 'lucide-react';

const fadeInUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.5 }
};

const services = [
  {
    icon: Ear,
    title: 'Culture assessment and listening',
    desc: 'Workplace surveys, focus groups, leadership interviews and evidence reviews.',
  },
  {
    icon: Users,
    title: 'Leadership and manager support',
    desc: 'Helping leaders and managers respond consistently and act on findings.',
  },
  {
    icon: BookOpen,
    title: 'Workplace learning',
    desc: 'Targeted sessions on mental health, management, communication, engagement and workplace pressure.',
  },
  {
    icon: Mic,
    title: 'Speaking and facilitated sessions',
    desc: 'Practical talks, roundtables and leadership discussions for operational sectors.',
  },
];

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 md:py-28 bg-gray-50" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2
          className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-carbon mb-12 tracking-tight"
          {...fadeInUp}
        >
          SUPPORT BUILT AROUND THE PROBLEM
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-6 mb-10">
          {services.map((svc, i) => (
            <motion.div
              key={svc.title}
              className="bg-white border border-gray-100 p-8"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="w-10 h-10 bg-golden flex items-center justify-center mb-5">
                <svc.icon className="w-5 h-5 text-carbon" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-carbon mb-3">{svc.title}</h3>
              <p className="text-sm text-carbon/70 leading-relaxed">{svc.desc}</p>
            </motion.div>
          ))}
        </div>

        <motion.div {...fadeInUp}>
          <Link
            to="/services"
            className="bg-carbon text-white px-7 py-3.5 font-semibold text-sm hover:bg-carbon/90 transition-colors inline-flex items-center"
            data-testid="services-view-btn"
          >
            View all services
            <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ServicesSection;
